<div class="footer">
  <div class="logo">
    <a routerLink="/home" routerLinkActive="active">
      <h1>bourne bespoke</h1>
      <div class="tag">
        <i class="fa-solid fa-circle"></i>
        <h2>creative home enhancement</h2>
        <i class="fa-solid fa-circle"></i>
      </div>
    </a>
  </div>

  <div class="nav">
    <ul>
      <li>
        <a routerLink="/home" routerLinkActive="active">Home</a>
      </li>
      <li>
        <a routerLink="/about" routerLinkActive="active">About</a>
      </li>
      <li>
        <a routerLink="/creations" routerLinkActive="active">Creations</a>
      </li>
      <li>
        <a routerLink="/contact-us" routerLinkActive="active">Contact Us</a>
      </li>
    </ul>
  </div>
  <div class="socials">
    <a href="tel:+447512371898" aria-label="Call +447512371898">
      <i class="fa-solid fa-phone"></i>
    </a>
    <a routerLink="/contact-us" aria-label="contact us">
      <i class="fa-solid fa-envelope"></i>
    </a>
    <a
      href="https://www.instagram.com/bournebespoke"
      target="_blank"
      aria-label="go to https://www.instagram.com/bournebespoke"
    >
      <i class="fa-brands fa-instagram"></i>
    </a>
    <a
      href="https://www.tiktok.com/@bournebespoke"
      target="_blank"
      aria-label="go to https://www.tiktok.com/@bournebespoke"
    >
      <i class="fa-brands fa-tiktok"></i>
    </a>
  </div>
  <div class="copyright">
    <p>&copy; AZUI LTD 2024. All rights reserved</p>
  </div>
  <!-- <div class="legal">
    <a routerLink="/privacy-policy" routerLinkActive="active">
      Privacy Policy
    </a>
    <a routerLink="/t&cs" routerLinkActive="active"> Terms & Conditions </a>
  </div> -->
</div>
